import { Component, OnInit, Output, EventEmitter, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { LogoContentService } from '../../../core/routing/services/asset-library/logo-content.service';
import { CommonService } from '../../../common/services/common.service';
import { StoreLogoService } from '../../../core/routing/services/asset-library/store-logo.service';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { GetStoreLogoByUserResponse, StoreLogoViewModel, StoreLogoConfiguration, CreateStoreLogoResponse } from '../../../modules/asset-library/logo-content/interfaces/store-logo.i';
import { ProfileStoreService } from '../../../modules/create-profile/store/profile.store';
import { StoreLogo, ProfileRequest } from '../../../modules/create-profile/interface/profile.i';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { AppGlobal } from '../../../core/state/app-global';
import { User } from '../../../modules/account/login/_models/user.model';
import { DevicesService } from '../../../core/routing/services/devices/devices.service';
import { ElementAst, NONE_TYPE } from '@angular/compiler';
import { LogoContentComponent } from '../../asset-library/logo-content/logo-content.component';
import { DevicesConstants } from '../../../../app/core/routing/services/devices/constants/devices.constants';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-store-logo',
  templateUrl: './store-logo.component.html',
  styleUrls: ['./store-logo.component.scss']
})

export class StoreLogoComponent implements OnInit, OnDestroy {
  @Output() readonly setLogoContentTab = new EventEmitter<any>();
  @Output() readonly setTabIndex = new EventEmitter<any>();
  @Output() readonly disabledLogoContentTab = new EventEmitter<any>();
  @ViewChild('container') readonly scroller: ElementRef;
  @ViewChild(LogoContentComponent) childComp: LogoContentComponent;

  placement: string;
  tabIndex = 0;
  openModalPopup = false;
  storeLogoOtherData = true;
  defaultStoreLogos: StoreLogoViewModel[] = [];
  otherStoreLogos: StoreLogoViewModel[] = [];
  storelogos: StoreLogoViewModel[];
  selectedLogoForProfile: any = [];
  showOnDevice: boolean;
  dataToProfile: any;
  storeLogoBgColor: string;
  isImageSizeError: boolean;
  isImageTypeError: boolean;
  isImageUploadError: boolean;
  isimageFormat: boolean;
  livePreviewData: any = [];
  skip: string;
  send: string;
  profileStoreLogoData: any = [];
  profileData: ProfileRequest;
  removeConstraints: boolean;
  isRemoveEnabled: boolean;
  displayLogoContentGroups = [];
  successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
  storeLogoLabel = GlobalConstants.STORE_LOGO_LABEL;
  description = DevicesConstants.STORE_LOGO_DESC;
  selctedContGrpsForProfile: any = {
    contentGrps: []
  };
  isLogoSelected = true;
  removeButton = true;
  storeLogoId: string;
  logoContentId: string;
  settings: {};
  storeDataDevice: String;
  direction: string;
  logoContentLength: number;
  isRetailerId;
  isCancel = false;
  isLogoRemoved = true;
  showRetailGif = false;
  retailerUserId = sessionStorage.getItem('retailerId');
  noLogosMsg: boolean;
  isStoreLogoRemoved = true;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private router: Router,
    private storeLogoService: StoreLogoService,
    private cmnService: CommonService, private logoContentService: LogoContentService,
    private profileStoreService: ProfileStoreService,
    private createProfileService: CreateProfileService,
    private appGlobal: AppGlobal,
    private deviceService: DevicesService,
    private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.isRetailerId = sessionStorage.getItem('retailerId') !== 'undefined';
    this.direction = this.cmnService.direction;
    // this.placement = this.direction === "rtl" ? 'right' :'right';
    this.storeDataDevice = '';
    this.logoContentId = '';
    this.skip = GlobalConstants.SKIP;
    this.send = GlobalConstants.SEND;
    this.storeLogoBgColor = GlobalConstants.STORELOGO_BGCOLOR;
    this.getAllStoreLogosByUser();
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userAccount: User) => {
        this.isRemoveEnabled = userAccount.isRemoveEnabled;
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setIndex(value: number) {
    this.tabIndex = value;
  }

  setStoreLogo(logo: any) {
    this.isLogoSelected = false;
    let defaultLogoSelected: StoreLogoViewModel[] = [];
    defaultLogoSelected = this.setDefaultLogoTabWise(this.defaultStoreLogos, logo, this.otherStoreLogos);
    this.setLivePreview();
  }

  setDefaultLogoTabWise(defaultStoreLogoList: StoreLogoViewModel[], selectedItem, storeLogoMasterList: StoreLogoViewModel[]) {
    let filteredCollection = storeLogoMasterList.filter(({ id }) => id !== selectedItem.id);
    this.otherStoreLogos = filteredCollection;
    if (defaultStoreLogoList.length < 1) {
      defaultStoreLogoList.push(selectedItem);
      defaultStoreLogoList[0].isdefault = true;
    } else {
      const data = defaultStoreLogoList.pop();
      defaultStoreLogoList.push(selectedItem);
      defaultStoreLogoList[0].isdefault = true;
      this.otherStoreLogos.push(data);
      this.isStoreLogoRemoved = true;
    }
    defaultStoreLogoList = Object.assign([], defaultStoreLogoList);
    return defaultStoreLogoList;
  }

  getAllStoreLogosByUser() {
    this.storeLogoService.getAllStoreLogoByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllStoreLogoResponse => {
        const storeLogos = [];
        const getStoreLogoByUserResponse: GetStoreLogoByUserResponse = getAllStoreLogoResponse as GetStoreLogoByUserResponse;

        getStoreLogoByUserResponse.storeLogo.forEach(storeLogo => {
          const reader = new FileReader();
          const storeLogoViewModel: StoreLogoViewModel = storeLogo as StoreLogoViewModel;
          this.storeLogoService.getStoreLogoById(storeLogo.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(imageData => {
              reader.addEventListener('load', () => {
                storeLogoViewModel.imageData = reader.result;
                const storeLogoConfiguration = JSON.parse(storeLogo.configurations) as StoreLogoConfiguration;
                storeLogoViewModel.fileName = storeLogoConfiguration.fileName;
                storeLogos.push(storeLogoViewModel);
                storeLogos.forEach(ele => {
                  ele.shortFileName = this.getShortFileName(ele.fileName);
                  ele.isdefault = ele.isdefault ? ele.isdefault : false;
                  ele.updateTime = new Date(ele.updateTime);
                  ele.updateTimeDisplay = new Date(ele.updateTime).toLocaleString()
                    .replace(',', '');
                });
                const existingProfileData = this.profileStoreService.currentWorkingProfile;
                if (existingProfileData && existingProfileData?.profileId) {
                  this.profileData = existingProfileData as ProfileRequest;
                  if (this.profileStoreLogoData?.length) { // if Edit profilelogo
                    this.defaultStoreLogos = storeLogos.filter(ele => this.profileStoreLogoData[0].storeLogoId === ele.id);
                    this.otherStoreLogos = storeLogos.filter(ele => this.profileStoreLogoData[0].storeLogoId !== ele.id);
                    if (this.profileStoreLogoData[0].bgColor) { //Condition to handle if bgColor doesn't exist already.
                      this.storeLogoBgColor = this.profileStoreLogoData[0].bgColor;
                    }
                  } else {
                    this.defaultStoreLogos = storeLogos.filter(ele => ele.isdefault);
                    this.otherStoreLogos = storeLogos.filter(ele => !ele.isdefault);
                  }
                  this.noLogosMsg = (this.defaultStoreLogos.length === 0) && (this.otherStoreLogos.length === 0) || false;
                } else {
                  this.defaultStoreLogos = storeLogos.filter(ele => ele.isdefault);
                  this.otherStoreLogos = storeLogos.filter(ele => !ele.isdefault);
                  this.noLogosMsg = (this.defaultStoreLogos.length === 0) && (this.otherStoreLogos.length === 0) || false;
                }
                this.setLivePreview();
                if (this.defaultStoreLogos.length === 0) {
                  this.disabledLogoContentTab.emit(true);
                }
              }, false);

              if (imageData) {
                reader.readAsDataURL(imageData);
              }
            },
              error => {
                // do something
              });
        });
      },
        error => {
          if (this.defaultStoreLogos.length === 0) {
            this.disabledLogoContentTab.emit(true);
          }
        });
  }
  cancel() {
    this.isCancel = true;
    this.openModalPopup = !this.openModalPopup;
  }
  processFile(imageInput: any) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();
    const fileType = file.type.split('/')[1];
    if (file.type.split('/')[0] === GlobalConstants.FILE_TYPE_IMAGE) {
      this.isImageSizeError = file.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
      this.isImageTypeError = fileType !== GlobalConstants.CONTENT_TYPE_JPEG &&
        fileType !== GlobalConstants.CONTENT_TYPE_PNG &&
        fileType !== GlobalConstants.CONTENT_TYPE_GIF;
      if (this.isRemoveEnabled) {
        this.isImageSizeError = false;
      }
      this.isImageUploadError = (this.isImageSizeError || this.isImageTypeError || (this.isImageSizeError && this.isImageTypeError));
      this.isimageFormat = true;
    } else {
      this.isimageFormat = false;
      this.isImageTypeError = true;
      this.isImageUploadError = true;
    }
    if (!this.isImageUploadError) {
      reader.addEventListener('load', (event: any) => {
        const storeLogo = {
          fileName: file.name
        };
        this.storeLogoService.createStoreLogo(JSON.stringify(storeLogo))
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(createStoreLogo => {
            const createStoreLogoResponse: CreateStoreLogoResponse = createStoreLogo as CreateStoreLogoResponse;
            const storeLogoViewModel: StoreLogoViewModel = createStoreLogoResponse.storeLogo as StoreLogoViewModel;
            this.storeLogoService.uploadImage(file, createStoreLogoResponse.storeLogo.id, file.name.split('.')
              .pop())
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe(() => {
                if (!this.otherStoreLogos || (this.otherStoreLogos && this.otherStoreLogos.length === 0)) {
                  this.otherStoreLogos = [];
                }
                storeLogoViewModel.imageData = event.target.result;
                storeLogoViewModel.shortFileName = this.getShortFileName(file.name);
                storeLogoViewModel.fileName = file.name;
                storeLogoViewModel.updateTime = new Date(storeLogoViewModel.updateTime);
                storeLogoViewModel.updateTimeDisplay = new Date(storeLogoViewModel.updateTime).toLocaleString()
                  .replace(',', '');
                this.otherStoreLogos.push(storeLogoViewModel);
                this.noLogosMsg = (this.otherStoreLogos.length === 0) || false;
                this.sortByCreatedDate();
              },
                error => {
                  // do something
                });
          },
            error => {
              // do something
            });
      });
    }

    reader.readAsDataURL(file);
  }
  getShortFileName(fileName: string): string {
    let finalName: string;
    if (fileName?.split('.')[0].length > 7) {
      let flname = fileName;
      const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
      flname = fileName.substring(0, 10);
      finalName = `${flname}...${extension}`;
    } else {
      finalName = fileName;
    }

    return finalName;
  }
  closePopup() {
    this.openModalPopup = !this.openModalPopup;
    location.reload();//IIT2-12797
  }
  sendToUpdateAllDevices(action: string) {
    this.settings = {};
    // II-3326
    if (this.defaultStoreLogos.length > 0) {
      this.settings['storeLogos'] = [
        {
          "storeLogoId": this.defaultStoreLogos[0].id,
          "showOnDevice": true,
          'bgColor': this.storeLogoBgColor
        }];
    }
    // II-3326 end 

    // None case
    if (this.logoContentId === undefined) {
      this.settings['logoContents'] = [];
    }
    else if (this.logoContentId !== '') {
      this.settings['logoContents'] = [{
        "logoContentId": this.logoContentId,
        "showOnDevice": true
      }];
    }
    else {
      this.settings['logoContents'] = [];
      for (let i = 0; i < this.displayLogoContentGroups.length; i++) {
        this.settings['logoContents'].push({
          "logoContentId": this.displayLogoContentGroups[i].id,
          "showOnDevice": false
        });
      }
    }
    if (action === GlobalConstants.SEND && this.defaultStoreLogos.length > 0) {
      this.selectedLogoForProfile = [];
      this.selectedLogoForProfile.push({
        storeLogoId: this.defaultStoreLogos[0].id,
        showOnDevice: true,
        bgColor: this.storeLogoBgColor
      });

    }
    if (action === GlobalConstants.SKIP) {
      this.cmnService.emitDataToProfile({ page: GlobalConstants.STORE_PAGE, dataSet: GlobalConstants.SKIP });
    }
    this.deviceService.updateAllDevices(JSON.stringify(this.settings), this.retailerUserId)
      .pipe(first())
      .subscribe(response => { });
    this.setLogoContentTab.emit(GlobalConstants.CREATE_PROFILE);
    this.setTabIndex.emit(1);
    this.openModalPopup = !this.openModalPopup;
    this.googleAnalyticsService.pushUpdateLogo();
  }

  setLivePreview() {
    this.livePreviewData = [];
    this.livePreviewData.push({
      imageData: this.defaultStoreLogos[0]?.imageData,
      bgColor: this.storeLogoBgColor
    });
    this.cmnService.emitLivePreviewDataToProfile(this.livePreviewData);
  }

  updateBgColor(value: string) {
    this.isLogoSelected = false;
    this.storeLogoBgColor = value;
    this.setLivePreview();
  }

  sortByCreatedDate() {
    this.otherStoreLogos.sort((logo1, logo2) => (logo2.updateTime as any) - (logo1.updateTime as any));
  }

  setAsDefaultStoreLogo(storeLogoId: string, isDefault: boolean) {
    this.isLogoRemoved = false;

    if (!isDefault) {

      this.defaultStoreLogos.forEach(element => {

        element.isdefault = false;
      });
      this.otherStoreLogos = this.otherStoreLogos.concat(this.defaultStoreLogos);
      this.defaultStoreLogos.pop();
    } else {

      const storeLogos = this.defaultStoreLogos.concat(this.otherStoreLogos);
      storeLogos.forEach(element => {

        element.isdefault = false;
        if (element.id === storeLogoId) {
          element.isdefault = true;
          this.defaultStoreLogos.push(element);
        }
      });
      this.defaultStoreLogos = storeLogos.filter(ele => ele.isdefault);
      this.otherStoreLogos = storeLogos.filter(ele => !ele.isdefault);
    }
  }
  getLogoId(data) {
    this.isLogoSelected = Array.isArray(data);
    this.logoContentId = Array.isArray(data) ? this.logoContentId = '' : this.logoContentId = data.id;
    this.displayLogoContentGroups = data;
  }

  scrollNext() {
    this.scroller.nativeElement.scrollTo({ left: (this.scroller.nativeElement.scrollLeft + 150), behavior: 'smooth' });
  }

  scrollPrev() {
    this.scroller.nativeElement.scrollTo({ left: (this.scroller.nativeElement.scrollLeft - 150), behavior: 'smooth' });
  }

  createNewLogoContent() {

    this.childComp.createNewLogoContent();

  }

}
